'use client';

import { c as _c } from "react/compiler-runtime";
import { useDatabaseContext } from '@shared/utils/context/DatabaseContext';
import { AlertTriangle, Database } from 'lucide-react';
import Button from '../common/Button';
interface DatabaseDisabledStateProps {
  title?: string;
  description?: string;
  showRetryButton?: boolean;
}
const DatabaseDisabledState: React.FC<DatabaseDisabledStateProps> = t0 => {
  const $ = _c(30);
  const {
    title,
    description,
    showRetryButton: t1
  } = t0;
  const showRetryButton = t1 === undefined ? true : t1;
  const {
    state: t2,
    retryDatabase
  } = useDatabaseContext();
  const {
    disabled,
    error
  } = t2;
  let t3;
  if ($[0] !== retryDatabase) {
    t3 = async () => {
      await retryDatabase();
    };
    $[0] = retryDatabase;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  const handleRetryDatabase = t3;
  if (!disabled) {
    return null;
  }
  const hasError = !!error;
  const displayTitle = title || (hasError ? "Database Error" : "Database Disabled");
  const displayDescription = description || (hasError ? "The local database encountered an error and has been disabled." : "The local database is currently disabled. Enable it to use offline features.");
  const t4 = `mx-auto flex h-14 w-14 items-center justify-center rounded-full ${hasError ? "bg-destructive/10" : "bg-primary/10"}`;
  let t5;
  if ($[2] !== hasError) {
    t5 = hasError ? <AlertTriangle className="h-7 w-7 text-destructive" /> : <Database className="h-7 w-7 text-primary" />;
    $[2] = hasError;
    $[3] = t5;
  } else {
    t5 = $[3];
  }
  let t6;
  if ($[4] !== t4 || $[5] !== t5) {
    t6 = <div className={t4}>{t5}</div>;
    $[4] = t4;
    $[5] = t5;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  let t7;
  if ($[7] !== displayTitle) {
    t7 = <h3 className="text-lg font-semibold text-textPrimary">{displayTitle}</h3>;
    $[7] = displayTitle;
    $[8] = t7;
  } else {
    t7 = $[8];
  }
  let t8;
  if ($[9] !== displayDescription) {
    t8 = <p className="leading-relaxed text-textSecondary">{displayDescription}</p>;
    $[9] = displayDescription;
    $[10] = t8;
  } else {
    t8 = $[10];
  }
  let t9;
  if ($[11] !== error || $[12] !== hasError) {
    t9 = hasError && <div className="rounded-md border border-destructive/20 bg-destructive/5 p-3"><p className="text-xs text-destructive">{error}</p></div>;
    $[11] = error;
    $[12] = hasError;
    $[13] = t9;
  } else {
    t9 = $[13];
  }
  const t10 = hasError ? "Affected features:" : "Available when enabled:";
  let t11;
  if ($[14] !== t10) {
    t11 = <p className="mb-2 text-sm font-emphasis text-textPrimary">{t10}</p>;
    $[14] = t10;
    $[15] = t11;
  } else {
    t11 = $[15];
  }
  let t12;
  if ($[16] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = <p className="text-xs text-textSecondary">Analytics • Mood tracking • Private posts • Offline storage</p>;
    $[16] = t12;
  } else {
    t12 = $[16];
  }
  let t13;
  if ($[17] !== t11) {
    t13 = <div className="rounded-md border border-ds-border-standard bg-background-secondary p-3">{t11}{t12}</div>;
    $[17] = t11;
    $[18] = t13;
  } else {
    t13 = $[18];
  }
  let t14;
  if ($[19] !== handleRetryDatabase || $[20] !== hasError || $[21] !== showRetryButton) {
    t14 = showRetryButton && <div className="space-y-2"><Button text={hasError ? "Try Again" : "Enable Database"} onClick={handleRetryDatabase} classNames="w-full" /><p className="text-xs text-textSecondary">{hasError ? "This will attempt to reinitialize the database" : "Enable local storage for offline features"}</p></div>;
    $[19] = handleRetryDatabase;
    $[20] = hasError;
    $[21] = showRetryButton;
    $[22] = t14;
  } else {
    t14 = $[22];
  }
  let t15;
  if ($[23] !== t13 || $[24] !== t14 || $[25] !== t6 || $[26] !== t7 || $[27] !== t8 || $[28] !== t9) {
    t15 = <div className="w-full space-y-4 rounded-lg border border-ds-border-standard bg-background-secondary p-4 text-center">{t6}{t7}{t8}{t9}{t13}{t14}</div>;
    $[23] = t13;
    $[24] = t14;
    $[25] = t6;
    $[26] = t7;
    $[27] = t8;
    $[28] = t9;
    $[29] = t15;
  } else {
    t15 = $[29];
  }
  return t15;
};
export default DatabaseDisabledState;